import React, { useEffect, useState } from 'react'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import MDBox from 'components/MDBox';
import { Grid, Card, Box, Tabs, Tab } from '@mui/material';
import MDTypography from 'components/MDTypography';
import TabPanel from './../../components/TabPanel';
import GeneralInfo from './GeneralInfo';
import { getDepartmentInfo } from './../../api/routes';
import HeaderInfo from './HeaderInfo';
import About from './About';
import Services from './Services';
import FrequencyQuestions from './FrequencyQuestions';
import ContactUs from './ContactUs';
import Gallery from './Gallery';
import Comments from './Comments';
import { toast } from "react-toastify";

export default function Site() {
    const [tab, setTab] = useState(sessionStorage.getItem('siteTab') !== null ? JSON.parse(sessionStorage.getItem('siteTab')) : 0);
    const [departmentInfo, setDepartmentInfo] = useState([]);
    const handleChangeTab = (event, newValue) => {
        setTab(newValue);
        sessionStorage.setItem('siteTab', newValue)
    };
    useEffect(() => {
        getDepartmentInfo((isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setDepartmentInfo(data)
        })
    }, [])
    return (
        <>
            <DashboardLayout>
                <MDBox pt={2} mb={6}>
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={6}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                >
                                    <MDTypography variant="h6" color="white">
                                        اطلاعات سایت
                                    </MDTypography>
                                    <DashboardNavbar />
                                </MDBox>
                                <MDBox py={5} px={3}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <Tabs value={tab} onChange={handleChangeTab} textColor="primary" indicatorColor="primary">
                                            <Tab value={0} label="اطلاعات کلی" className='font-bold' />
                                            <Tab value={1} label="اطلاعات هدر" className='font-bold' />
                                            <Tab value={2} label="درباره ما" className='font-bold' />
                                            <Tab value={3} label="خدمات" className='font-bold' />
                                            <Tab value={4} label="نظرات بیمارن" className='font-bold' />
                                            <Tab value={5} label="سوالات متداول" className='font-bold' />
                                            <Tab value={6} label="ارتباط با ما" className='font-bold' />
                                            {/* <Tab value={7} label="بیمه های طرف قرارداد" className='font-bold' /> */}
                                            <Tab value={8} label="گالری" className='font-bold' />
                                        </Tabs>
                                    </Box>
                                    <TabPanel value={tab} index={0}>
                                        {departmentInfo.length > 0 && <GeneralInfo data={departmentInfo} />}
                                    </TabPanel>
                                    <TabPanel value={tab} index={1}>
                                        {departmentInfo.length > 0 && <HeaderInfo />}
                                    </TabPanel>
                                    <TabPanel value={tab} index={2}>
                                        {departmentInfo.length > 0 && <About />}
                                    </TabPanel>
                                    <TabPanel value={tab} index={3}>
                                        <Services />
                                    </TabPanel>
                                    <TabPanel value={tab} index={4}>
                                        <Comments />
                                    </TabPanel>
                                    <TabPanel value={tab} index={5}>
                                        <FrequencyQuestions />
                                    </TabPanel>
                                    <TabPanel value={tab} index={6}>
                                        <ContactUs />
                                    </TabPanel>
                                    <TabPanel value={tab} index={8}>
                                        <Gallery />
                                    </TabPanel>
                                </MDBox>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
            </DashboardLayout>
        </>
    )
}
